import {FailedRequestPayload} from './../types';
import {SessionState, SessionActionTypes, ActionTypes} from './types';

import type {IWHISession} from '@nib/types-session-api';

const initialState: SessionState = {
  session: undefined,
  loadingSession: true,
  fetchedSession: false,
  updatingSession: false,
  sessionError: null
};

const SessionReducer = (state = initialState, action: SessionActionTypes): SessionState => {
  switch (action.type) {
    case ActionTypes.INIT_SESSION_PENDING:
    case ActionTypes.FETCH_SESSION_PENDING: {
      return {
        ...state,
        loadingSession: true,
        fetchedSession: false,
        sessionError: null
      };
    }
    case ActionTypes.INIT_SESSION_FULFILLED:
    case ActionTypes.FETCH_SESSION_FULFILLED: {
      const iwhiSession = action.payload as IWHISession;
      return {
        ...state,
        ...iwhiSession,
        loadingSession: false,
        fetchedSession: true,
        sessionError: null
      };
    }
    case ActionTypes.INIT_SESSION_REJECTED:
    case ActionTypes.FETCH_SESSION_REJECTED: {
      const {error} = action.payload as FailedRequestPayload;
      return {
        ...state,
        loadingSession: false,
        fetchedSession: false,
        sessionError: error
      };
    }
    case ActionTypes.UPDATE_SESSION_PENDING: {
      return {
        ...state,
        updatingSession: true,
        sessionError: null
      };
    }
    case ActionTypes.UPDATE_SESSION_FULFILLED: {
      const iwhiSession = action.payload as IWHISession;
      return {
        ...state,
        ...iwhiSession,
        updatingSession: false,
        sessionError: null
      };
    }
    case ActionTypes.UPDATE_SESSION_REJECTED: {
      const {error} = action.payload as FailedRequestPayload;
      return {
        ...state,
        loadingSession: false,
        updatingSession: false,
        sessionError: error
      };
    }
    default: {
      return state;
    }
  }
};

export default SessionReducer;
